import { ComponentPropsWithoutRef } from 'react';
import { useFilterSectionIsShown } from 'components/filter/filters-next/useFilterSectionIsShown';
import { twMerge } from 'tailwind-merge';

interface FilterListSectionTitleProps extends ComponentPropsWithoutRef<'li'> {}
const FilterListSectionTitle = (props: FilterListSectionTitleProps) => {
    const { className = '', children } = props;
    const isShown = useFilterSectionIsShown();

    if (isShown) {
        return (
            <li className={twMerge('mb-1 list-none text-xs text-gray-500', className)}>
                {children}
            </li>
        );
    }

    return null;
};

export { FilterListSectionTitle };
